export const GENERIC_ERROR = 'generic_error';
export const OTP_CODE = 'otp_code';
export const PASSWORD = 'password';
export const PUBLIC_CREDENTIAL = 'public_credential';
export const SEND_OTP = 'send_otp';
export const TRY_ANOTHER_WAY = 'try_another_way';
